export class FileToUpload {
  fileName: string = "";
  fileSize: number = 0;
  fileType: string = "";
  lastModifiedTime: number = 0;
  lastModifiedDate: Date = null;
  fileAsBase64: string = "";
  userEmailId: string = "";
}

export class UserUploadDoc {
  emailId: string = "";
  fileName:string = "";
}

export class UserTemplate {
  FileName = "";
  UpdatedBy = "";
  Date = "";
  Download = "";
}